import React, { Fragment } from "react";
import { Link, withRouter } from "react-router-dom";
import ReactDOM from "react-dom";
import Skeleton from "@material-ui/lab/Skeleton";

import "./categoryCarousel.css";

// owl carousel

import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";

// Redux
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { singleCategoryData, mainCategories } from "../../actions/categories";
//components
import BreadCrumb from "../../components/breadcrumb/breadcrumb";

class Index extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      mainCategory: [],
      subCategories: "",
      subChildCat: [],
      mainRowOpen: false,
      subCatRowId: {},
      changingId: null,
      rowsTitle: "",
      chiledSubs: "",
      testCheck: "",
      matchedId: "",
      loading: false,
    };
  }

  fetchData = async () => {
    this.setState({ loading: true });
    const res = await this.props.singleCategoryData(
      window.location.toString().split("y/")[1]
    );
    this.setState({ mainCategory: res.data[0] });
    console.log(this.state.mainCategory);
    const s = document.createElement("script");
    s.type = "text/javascript";
    s.async = true;
    this.setState({ loading: false });
  };

  showSubCategories = (gotData, index, _index) => {
    console.log(index);
    this.setState({
      matchedId: index,
      mainRowOpen: true,
      subCatRowId: index,
      rowsTitle: gotData.name,
    });
  };

  closeSubCat = (index) => {
    this.setState({
      matchedId: !index,
      mainRowOpen: !this.state.mainRowOpen,
    });
  };

  async componentDidMount() {
    window.scrollTo(0, 0);
    await this.fetchData();
  }
  async componentWillReceiveProps() {
    if (
      this.props.match.params.slug !== window.location.toString().split("y/")[1]
    ) {
      window.scrollTo(0, 0);
      await this.fetchData();
    }
  }
  focusInput = async (e, thisHello) => {
    e.preventDefault();

    let node = ReactDOM.findDOMNode(this[`${thisHello}`]).scrollIntoView({
      behavior: "smooth",
    });
  };

  options = {
    items: 6,
    margin: 10,
    nav: true,
    animateOut: true,
  };

  render() {
    const { mainCategory, loading } = this.state;

    const categories =
      mainCategory &&
      mainCategory.categories &&
      mainCategory.categories.length > 0 &&
      mainCategory.categories;

    return (
      <Fragment>
        <div className="category-wrapper">
          <div className="wrapper-90 max-1600">
            {<BreadCrumb title={mainCategory && mainCategory.name} />}
          </div>
          <div className="main-area">
            <div className="wrapper wrapper-90 max-1600">
              <div className="row" id="firstSlider">
                <div className="col-md-12">
                  <div className="content">
                    <div className="row">
                      <div className="col-lg-10 col-md-9 col-sm-12">
                        <h2
                          className="pt-3"
                          style={{ color: "#221924", fontWeight: "700" }}
                        >
                          {mainCategory && mainCategory.name}
                        </h2>
                        <div className="row" id="showcase">
                          {categories &&
                            categories.length > 0 &&
                            categories.map((item, index) =>
                              item.subcategories &&
                              item.subcategories.length > 0 ? (
                                <div
                                  key={index}
                                  className="col-lg-3 col-md-4 col-sm-6 col-6 n1"
                                >
                                  <Link
                                    onClick={(e) =>
                                      this.focusInput(e, item._id)
                                    }
                                  >
                                    <span className="links-text">
                                      {item.name}
                                    </span>
                                  </Link>{" "}
                                </div>
                              ) : null
                            )}
                        </div>
                      </div>
                      <div className="col-lg-2 col-md-3 d-md-block d-none text-center">
                        <img
                          src={mainCategory && mainCategory.image}
                          width="100%"
                          className="category-header-img"
                          alt=""
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="main-area-sm">
            <img
              src="http://res.cloudinary.com/sundialhomeproducts/image/upload/v1598953287/axr4wpo65kv1ye0xaz5f.png"
              width="100%"
              height="100%"
              alt=""
            />
            {
              <h1 className="Category-roadsign">
                {mainCategory && mainCategory.name}
              </h1>
            }
          </div>

          <div className="cate-sliders w-100 max-1780">
            {!loading ? (
              <>
                {mainCategory &&
                  mainCategory.categories &&
                  mainCategory.categories.length > 0 &&
                  mainCategory.categories.length > 0 &&
                  mainCategory.categories.map((item, index, test) => (
                    <div
                      key={index}
                      className="container-fluid categoriesSlidContainer"
                      ref={(el) => (this.instance = el)}
                    >
                      {item.subcategories && item.subcategories.length !== 0 ? (
                        <>
                          <div className={`row py-2 mainCategory ${index}`}>
                            {this.state.mainRowOpen ? (
                              <div className="container-fluid">
                                {this.state.subCatRowId === index ? (
                                  <div className="row emptyFor-sub-categories">
                                    <div className="col-md-2 slide-lef-heading back-c-heading">
                                      <div
                                        className="backto-categ-btn"
                                        onClick={() => this.closeSubCat(item)}
                                      >
                                        <span>
                                          <i className="fa fa-angle-left" />
                                        </span>
                                        &nbsp;
                                        <span className="back-categ-btnTxt">
                                          Back
                                        </span>
                                      </div>
                                      <h4 className="category-right-heading">
                                        {this.state.rowsTitle}
                                      </h4>
                                    </div>
                                    <div className="col-md-10">
                                      <div className="row">
                                        {item.subcategories.map((item) => {
                                          return (
                                            <>
                                              {item.childsubcategories.map(
                                                (item) => {
                                                  return (
                                                    <div className="col-md-6">
                                                      <div className="sub-categories">
                                                        <Link
                                                          to={`/products/${item.slug}/1`}
                                                          className="sub-category"
                                                        >
                                                          <span className="sub-cat-img">
                                                            <img
                                                              src={item.image}
                                                              style={{
                                                                width: "40px",
                                                                height: "40px",
                                                              }}
                                                              alt=""
                                                            />
                                                          </span>
                                                          <span className="sub-cat-name">
                                                            {item.name}
                                                          </span>
                                                          <span>
                                                            <i className="fa fa-angle-right" />
                                                          </span>
                                                        </Link>
                                                      </div>
                                                    </div>
                                                  );
                                                }
                                              )}
                                            </>
                                          );
                                        })}
                                      </div>
                                    </div>
                                  </div>
                                ) : null}
                              </div>
                            ) : null}

                            <div className="container" id="small-categoryRow1">
                              <div className="row categorySmall-screen-row">
                                <div className="col-md-12 small-padding0">
                                  <Link
                                    style={{ color: "inherit" }}
                                    to={`/sub-category/${item && item.slug}`}
                                  >
                                    <div className="smallScreen-rows-categry">
                                      <div className="smallCategory-row-img">
                                        <img
                                          className="smallCategory-img"
                                          src={
                                            item && item.image
                                              ? item.image
                                              : "http://res.cloudinary.com/dataflows/image/upload/v1586272334/ygdi9vj16naflzjbtkmi.jpg"
                                          }
                                          alt={item && item.name}
                                        />
                                        <span>{item && item.name}</span>
                                      </div>
                                      <div className="">
                                        <i className="fa fa-arrow-right"></i>
                                      </div>
                                    </div>
                                  </Link>
                                </div>
                              </div>
                            </div>

                            <div className="container-fluid">
                              <div className="row">
                                <div
                                  className={`col-md-2 slide-lef-heading  ${
                                    this.state.matchedId === index
                                      ? "d-none"
                                      : "d-flex"
                                  } hide-sm-category`}
                                  ref={(el) => {
                                    this[`${item._id}`] = el;
                                  }}
                                >
                                  <h4>{item && item.name}</h4>
                                </div>
                                <div
                                  className={`col-md-10 ${
                                    this.state.matchedId === index
                                      ? "d-none"
                                      : "d-block"
                                  } hide-sm-category px-0`}
                                >
                                  <div className="categoriesslider">
                                    <div>
                                      <OwlCarousel
                                        className="allCategory-slider"
                                        {...this.options}
                                      >
                                        {item.subcategories &&
                                          item.subcategories.length > 0 &&
                                          item.subcategories.map(
                                            (_item, _index) =>
                                              _item.categoryId === item._id && (
                                                <div
                                                  className="category-item"
                                                  key={_index}
                                                  style={{
                                                    marginLeft:
                                                      _index ===
                                                        item.subcategories
                                                          .length -
                                                          1 && 10,
                                                  }}
                                                >
                                                  {_item.childsubcategories &&
                                                  _item.childsubcategories
                                                    .length > 0 ? (
                                                    <Fragment>
                                                      <span
                                                        className="categoriy-img-link hav-subCategories"
                                                        style={{
                                                          margin: "-5px",
                                                        }}
                                                        onClick={() =>
                                                          this.showSubCategories(
                                                            item,
                                                            index,
                                                            _index
                                                          )
                                                        }
                                                      >
                                                        <img
                                                          src={_item.image}
                                                          alt=""
                                                          width="100%"
                                                        />
                                                        <div></div>
                                                        <span className="categ1-title">
                                                          <Link
                                                            onClick={() => {
                                                              this.setState({
                                                                subChildCat:
                                                                  _item.childsubcategories,
                                                              });
                                                            }}
                                                          >
                                                            {_item.name}
                                                          </Link>
                                                        </span>
                                                      </span>
                                                    </Fragment>
                                                  ) : (
                                                    <Link
                                                      to={`/products/${_item.slug}/1`}
                                                      className="categoriy-img-link"
                                                      style={{ margin: "-5px" }}
                                                    >
                                                      <img
                                                        src={_item.image}
                                                        alt=""
                                                        width="100%"
                                                      />
                                                      <span
                                                        className="categ1-title"
                                                        onClick={() => {
                                                          this.props.history.push(
                                                            `/products/${_item.slug}`
                                                          );
                                                        }}
                                                      >
                                                        <Link
                                                          to={`/products/${_item.slug}`}
                                                        >
                                                          {_item.name}
                                                        </Link>
                                                      </span>
                                                    </Link>
                                                  )}
                                                </div>
                                              )
                                          )}
                                      </OwlCarousel>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      ) : null}
                    </div>
                  ))}
              </>
            ) : (
              <>
                <div className="container">
                  <div className="row">
                    <div className="col-md-2">
                      <Skeleton variant="rect" width={210} height={118} />
                    </div>
                    <div className="col-md-2">
                      <Skeleton variant="rect" width={210} height={118} />
                    </div>
                    <div className="col-md-2">
                      <Skeleton variant="rect" width={210} height={118} />
                    </div>
                    <div className="col-md-2">
                      <Skeleton variant="rect" width={210} height={118} />
                    </div>
                    <div className="col-md-2">
                      <Skeleton variant="rect" width={210} height={118} />
                    </div>
                    <div className="col-md-2">
                      <Skeleton variant="rect" width={210} height={118} />
                    </div>
                  </div>
                </div>
                <div className="container mt-5">
                  <div className="row">
                    <div className="col-md-2">
                      <Skeleton variant="rect" width={210} height={118} />
                    </div>
                    <div className="col-md-2">
                      <Skeleton variant="rect" width={210} height={118} />
                    </div>
                    <div className="col-md-2">
                      <Skeleton variant="rect" width={210} height={118} />
                    </div>
                    <div className="col-md-2">
                      <Skeleton variant="rect" width={210} height={118} />
                    </div>
                    <div className="col-md-2">
                      <Skeleton variant="rect" width={210} height={118} />
                    </div>
                    <div className="col-md-2">
                      <Skeleton variant="rect" width={210} height={118} />
                    </div>
                  </div>
                </div>
                <div className="container mt-5">
                  <div className="row">
                    <div className="col-md-2">
                      <Skeleton variant="rect" width={210} height={118} />
                    </div>
                    <div className="col-md-2">
                      <Skeleton variant="rect" width={210} height={118} />
                    </div>
                    <div className="col-md-2">
                      <Skeleton variant="rect" width={210} height={118} />
                    </div>
                    <div className="col-md-2">
                      <Skeleton variant="rect" width={210} height={118} />
                    </div>
                    <div className="col-md-2">
                      <Skeleton variant="rect" width={210} height={118} />
                    </div>
                    <div className="col-md-2">
                      <Skeleton variant="rect" width={210} height={118} />
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>

          <div ref={(el) => (this.instance = el)}></div>
        </div>
      </Fragment>
    );
  }
}

singleCategoryData.propTypes = {
  singleCategoryData: PropTypes.func.isRequired,
};

export default connect(null, { singleCategoryData })(withRouter(Index));
